import React, {Component} from 'react'
import { withRouter } from 'react-router-dom'
import asyncWrapper from '../../../../../shared/javascripts/hocs/asyncWrapper'
import { Panel } from 'react-bootstrap'
import Loading from '../../../../../shared/javascripts/components/Loading'
import LoadingError from '../../../../../shared/javascripts/components/LoadingError'
import MonitoringApi from '../../api/MonitoringApi'
import ServerPanel from './ServerPanel'
import DataPanel from './DataPanel'

class TabContent extends Component {
  constructor(props) {
    super(props)
  }

  componentDidMount() {
    MonitoringApi.statuses('operations')
      .then(this.props.handleErrors)
      .then(response => {
        this.props.saveOperationsData(response)
      }).then(() => this.props.setLoading()).catch(error => console.log(error))
  }

  render() {
    if(this.props.loading) { return <Loading />}
    const operationsData = this.props.operationsData;
    if(operationsData.error || operationsData.data.source_error) {return <LoadingError message={operationsData.error || operationsData.data.source_error} />}
    return(
      <div className='TabContent'>
        <ServerPanel data={operationsData.data} />
        <DataPanel data={operationsData.data} />
      </div>
    )
  }
}

export default asyncWrapper(withRouter(TabContent))


// WEBPACK FOOTER //
// ./src/admin/statuses/javascripts/components/Operations/TabContent.jsx